export default __webpack_public_path__ + "static/media/icon_7_0.d7fad0b7.svg";